import React, { useEffect } from 'react'

import SignIn from './SignIn/SignIn'
import SignInVerify from './SignIn/SignInVerify'
import SignInForgotPassword from './SignIn/SignInForgotPassword'
import SignUpHome from './SignUp/SignUpHome'
import SignUpForm from './SignUp/SignUpForm'
import SignUpPassword from './SignUp/SignUpPassword'
import SignUpVerify from './SignUp/SignUpVerify'
import SigninForgotFinish from './SignIn/SigninForgotFinish'
import { paths } from '../links'
import { createStackNavigator } from '@react-navigation/stack'
import { headerMode, screenOptions } from '../../utils/helpers/commonUtils'
import SignInPassword from './SignIn/SignInPassword'
import useRecaptcha from './useRecaptcha'

const Stack = createStackNavigator()

export default () => {
  const recaptcha = useRecaptcha('signin')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => recaptcha.cleanVerifier, [])

  return (
    <Stack.Navigator
      screenOptions={screenOptions}
      headerMode={headerMode}
      initialRouteName={paths.Auth.SignIn}
    >
      <Stack.Screen name={paths.Auth.SignIn} component={SignIn} />
      <Stack.Screen
        name={paths.Auth.SignInPassword}
        component={SignInPassword}
      />
      <Stack.Screen name={paths.Auth.SignInVerify} component={SignInVerify} />
      <Stack.Screen name={paths.Auth.SignUpHome} component={SignUpHome} />
      <Stack.Screen
        name={paths.Auth.SignInForgotPassword}
        component={SignInForgotPassword}
      />
      <Stack.Screen
        name={paths.Auth.SignInForgotFinish}
        component={SigninForgotFinish}
      />
      <Stack.Screen name={paths.Auth.SignUp} component={SignUpHome} />
      <Stack.Screen
        name={paths.Auth.SignUpPassword}
        component={SignUpPassword}
      />
      <Stack.Screen name={paths.Auth.SignUpVerify} component={SignUpVerify} />
      <Stack.Screen name={paths.Auth.SignUpForm} component={SignUpForm} />
    </Stack.Navigator>
  )
}
